<template>
<div class="main">
	<Steps :index="0" product-name="同线工人保险" />
	<Applicant :info="info" :amount="amount" ref="applicant"/>
	<Recognize ref="recognize" :info="info" @set-amount="setAmount" @person-count-change="handlePersonCountChange"/>
	<div class="mt20 center">
        <p class="agree">保费合计：<span class="price">{{amount}}元</span></p>
        <p class="mt10">
            <Button type="primary" @click="sub" :loading="loading" :disabled="isPersonCountInvalid">立即投保</Button>
        </p>
    </div>
	<TrackNotice v-if="id&&$route.query.reset" />
</div>
</template>
<script>
import Steps from './common/steps'
import Recognize from './recognize'
import Applicant from './common/applicant'
import TrackNotice from '@/components/common/TrackNotice.vue';
import { mapState } from 'vuex'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ 
		Steps,
		Recognize,
		Applicant,
		TrackNotice
	},
	data () {
		return {
			info:{
				policyTimeType:"1"
			},
			amount: null,
			loading:false,
			id:this.$route.params.id,
			companyData:[],
			isPersonCountInvalid: false // 投保人数是否少于3人
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		})
	},
	watch:{
		userInfo(){
			this.checkLogin()
		}
	},
	created () {
		this.getUserInfo();
		if(this.checkLogin&&this.id){
			this.getInfo()
		}
	},
	mounted(){
		// 重新投保
		if(this.id&&this.$route.query.reset){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
	},
	methods:{
		async getUserInfo(){
			await this.$axios.post('/casual/company').then((res) => {
				this.$set(this.info, 'companyName', res.companyName);
			})
		},
		getPremium(){
			this.$refs.recognize.getPremium();
		},
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/casual/insurance/user.json.dst',{
				billNo: this.id
			}).then(res=>{
				if(res.beginDate){
					// 续保
					res.beginDate='';
					res.endDate='';
					this.$refs.recognize.setStartTimeOption()
				}
				this.info = {
					...this.info,
					...res
				};
				this.$forceUpdate()
			});
		},
		// 校验
		async sub () {
			let recognize = await this.$refs.recognize.val();
			if(!recognize){
				return;
			}
			this.loading = true;
			if(this.$route.query.reset){
				recognize.users.forEach((item)=>{ 
					if (item.id){
						delete  item.id;  
					}
				})
			}
		    this.$axios.post('/casual/insurance/save.json.all',recognize).then(async res=>{
				this.loading = false;
				if(res.code==10000000){
					// 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.data
					});
					if(!this.id||res.data!=this.id){
						this.$router.push(`/lineWork/fillin/${res.data}`)
					}
					this.$router.push('/lineWork/confirm/'+res.data);
				}else{
		            this.alert(res.msg)
		        }
			}).catch(err=>{
				this.loading = false;
			});
		},
		// 设置总费用
		setAmount(amount) {
			this.amount=amount;
		},
		// 处理投保人数变化
		handlePersonCountChange(isInvalid) {
			this.isPersonCountInvalid = isInvalid;
		}
	}
}
</script>
<style scoped lang="less">
	.draft{
		font-size: 18px;
		font-weight: bold;
	}
	.main{
		margin-top: 24px;
		padding :30px 40px;
	}
	.mt20{
	    // font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
	.text{
		font-size: 16px;
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/fillin.vue